

if (typeof ENV !== 'undefined' && ENV.MOMENT_LOCALE && ENV.MOMENT_LOCALE !== 'en') {
  function loadLocale(locale) {
    switch (locale) {
      
        case "moment/locale/af": return import(/* webpackChunkName: "moment/locale/af" */ "moment/locale/af.js");
      
        case "moment/locale/ar-dz": return import(/* webpackChunkName: "moment/locale/ar-dz" */ "moment/locale/ar-dz.js");
      
        case "moment/locale/ar-kw": return import(/* webpackChunkName: "moment/locale/ar-kw" */ "moment/locale/ar-kw.js");
      
        case "moment/locale/ar-ly": return import(/* webpackChunkName: "moment/locale/ar-ly" */ "moment/locale/ar-ly.js");
      
        case "moment/locale/ar-ma": return import(/* webpackChunkName: "moment/locale/ar-ma" */ "moment/locale/ar-ma.js");
      
        case "moment/locale/ar-sa": return import(/* webpackChunkName: "moment/locale/ar-sa" */ "moment/locale/ar-sa.js");
      
        case "moment/locale/ar-tn": return import(/* webpackChunkName: "moment/locale/ar-tn" */ "moment/locale/ar-tn.js");
      
        case "moment/locale/ar": return import(/* webpackChunkName: "moment/locale/ar" */ "moment/locale/ar.js");
      
        case "moment/locale/az": return import(/* webpackChunkName: "moment/locale/az" */ "moment/locale/az.js");
      
        case "moment/locale/be": return import(/* webpackChunkName: "moment/locale/be" */ "moment/locale/be.js");
      
        case "moment/locale/bg": return import(/* webpackChunkName: "moment/locale/bg" */ "moment/locale/bg.js");
      
        case "moment/locale/bm": return import(/* webpackChunkName: "moment/locale/bm" */ "moment/locale/bm.js");
      
        case "moment/locale/bn-bd": return import(/* webpackChunkName: "moment/locale/bn-bd" */ "moment/locale/bn-bd.js");
      
        case "moment/locale/bn": return import(/* webpackChunkName: "moment/locale/bn" */ "moment/locale/bn.js");
      
        case "moment/locale/bo": return import(/* webpackChunkName: "moment/locale/bo" */ "moment/locale/bo.js");
      
        case "moment/locale/br": return import(/* webpackChunkName: "moment/locale/br" */ "moment/locale/br.js");
      
        case "moment/locale/bs": return import(/* webpackChunkName: "moment/locale/bs" */ "moment/locale/bs.js");
      
        case "moment/locale/cs": return import(/* webpackChunkName: "moment/locale/cs" */ "moment/locale/cs.js");
      
        case "moment/locale/cv": return import(/* webpackChunkName: "moment/locale/cv" */ "moment/locale/cv.js");
      
        case "moment/locale/cy": return import(/* webpackChunkName: "moment/locale/cy" */ "moment/locale/cy.js");
      
        case "moment/locale/da": return import(/* webpackChunkName: "moment/locale/da" */ "moment/locale/da.js");
      
        case "moment/locale/de-at": return import(/* webpackChunkName: "moment/locale/de-at" */ "moment/locale/de-at.js");
      
        case "moment/locale/de-ch": return import(/* webpackChunkName: "moment/locale/de-ch" */ "moment/locale/de-ch.js");
      
        case "moment/locale/dv": return import(/* webpackChunkName: "moment/locale/dv" */ "moment/locale/dv.js");
      
        case "moment/locale/el": return import(/* webpackChunkName: "moment/locale/el" */ "moment/locale/el.js");
      
        case "moment/locale/en-au": return import(/* webpackChunkName: "moment/locale/en-au" */ "moment/locale/en-au.js");
      
        case "moment/locale/en-ca": return import(/* webpackChunkName: "moment/locale/en-ca" */ "moment/locale/en-ca.js");
      
        case "moment/locale/en-gb": return import(/* webpackChunkName: "moment/locale/en-gb" */ "moment/locale/en-gb.js");
      
        case "moment/locale/en-ie": return import(/* webpackChunkName: "moment/locale/en-ie" */ "moment/locale/en-ie.js");
      
        case "moment/locale/en-il": return import(/* webpackChunkName: "moment/locale/en-il" */ "moment/locale/en-il.js");
      
        case "moment/locale/en-in": return import(/* webpackChunkName: "moment/locale/en-in" */ "moment/locale/en-in.js");
      
        case "moment/locale/en-nz": return import(/* webpackChunkName: "moment/locale/en-nz" */ "moment/locale/en-nz.js");
      
        case "moment/locale/en-sg": return import(/* webpackChunkName: "moment/locale/en-sg" */ "moment/locale/en-sg.js");
      
        case "moment/locale/eo": return import(/* webpackChunkName: "moment/locale/eo" */ "moment/locale/eo.js");
      
        case "moment/locale/es-do": return import(/* webpackChunkName: "moment/locale/es-do" */ "moment/locale/es-do.js");
      
        case "moment/locale/es-mx": return import(/* webpackChunkName: "moment/locale/es-mx" */ "moment/locale/es-mx.js");
      
        case "moment/locale/es-us": return import(/* webpackChunkName: "moment/locale/es-us" */ "moment/locale/es-us.js");
      
        case "moment/locale/es": return import(/* webpackChunkName: "moment/locale/es" */ "moment/locale/es.js");
      
        case "moment/locale/et": return import(/* webpackChunkName: "moment/locale/et" */ "moment/locale/et.js");
      
        case "moment/locale/eu": return import(/* webpackChunkName: "moment/locale/eu" */ "moment/locale/eu.js");
      
        case "moment/locale/fi": return import(/* webpackChunkName: "moment/locale/fi" */ "moment/locale/fi.js");
      
        case "moment/locale/fil": return import(/* webpackChunkName: "moment/locale/fil" */ "moment/locale/fil.js");
      
        case "moment/locale/fo": return import(/* webpackChunkName: "moment/locale/fo" */ "moment/locale/fo.js");
      
        case "moment/locale/fr-ch": return import(/* webpackChunkName: "moment/locale/fr-ch" */ "moment/locale/fr-ch.js");
      
        case "moment/locale/fy": return import(/* webpackChunkName: "moment/locale/fy" */ "moment/locale/fy.js");
      
        case "moment/locale/ga": return import(/* webpackChunkName: "moment/locale/ga" */ "moment/locale/ga.js");
      
        case "moment/locale/gd": return import(/* webpackChunkName: "moment/locale/gd" */ "moment/locale/gd.js");
      
        case "moment/locale/gl": return import(/* webpackChunkName: "moment/locale/gl" */ "moment/locale/gl.js");
      
        case "moment/locale/gom-deva": return import(/* webpackChunkName: "moment/locale/gom-deva" */ "moment/locale/gom-deva.js");
      
        case "moment/locale/gom-latn": return import(/* webpackChunkName: "moment/locale/gom-latn" */ "moment/locale/gom-latn.js");
      
        case "moment/locale/gu": return import(/* webpackChunkName: "moment/locale/gu" */ "moment/locale/gu.js");
      
        case "moment/locale/hi": return import(/* webpackChunkName: "moment/locale/hi" */ "moment/locale/hi.js");
      
        case "moment/locale/hr": return import(/* webpackChunkName: "moment/locale/hr" */ "moment/locale/hr.js");
      
        case "moment/locale/hu": return import(/* webpackChunkName: "moment/locale/hu" */ "moment/locale/hu.js");
      
        case "moment/locale/id": return import(/* webpackChunkName: "moment/locale/id" */ "moment/locale/id.js");
      
        case "moment/locale/is": return import(/* webpackChunkName: "moment/locale/is" */ "moment/locale/is.js");
      
        case "moment/locale/it-ch": return import(/* webpackChunkName: "moment/locale/it-ch" */ "moment/locale/it-ch.js");
      
        case "moment/locale/it": return import(/* webpackChunkName: "moment/locale/it" */ "moment/locale/it.js");
      
        case "moment/locale/ja": return import(/* webpackChunkName: "moment/locale/ja" */ "moment/locale/ja.js");
      
        case "moment/locale/jv": return import(/* webpackChunkName: "moment/locale/jv" */ "moment/locale/jv.js");
      
        case "moment/locale/ka": return import(/* webpackChunkName: "moment/locale/ka" */ "moment/locale/ka.js");
      
        case "moment/locale/kk": return import(/* webpackChunkName: "moment/locale/kk" */ "moment/locale/kk.js");
      
        case "moment/locale/km": return import(/* webpackChunkName: "moment/locale/km" */ "moment/locale/km.js");
      
        case "moment/locale/kn": return import(/* webpackChunkName: "moment/locale/kn" */ "moment/locale/kn.js");
      
        case "moment/locale/ko": return import(/* webpackChunkName: "moment/locale/ko" */ "moment/locale/ko.js");
      
        case "moment/locale/ku": return import(/* webpackChunkName: "moment/locale/ku" */ "moment/locale/ku.js");
      
        case "moment/locale/ky": return import(/* webpackChunkName: "moment/locale/ky" */ "moment/locale/ky.js");
      
        case "moment/locale/lb": return import(/* webpackChunkName: "moment/locale/lb" */ "moment/locale/lb.js");
      
        case "moment/locale/lo": return import(/* webpackChunkName: "moment/locale/lo" */ "moment/locale/lo.js");
      
        case "moment/locale/lt": return import(/* webpackChunkName: "moment/locale/lt" */ "moment/locale/lt.js");
      
        case "moment/locale/lv": return import(/* webpackChunkName: "moment/locale/lv" */ "moment/locale/lv.js");
      
        case "moment/locale/me": return import(/* webpackChunkName: "moment/locale/me" */ "moment/locale/me.js");
      
        case "moment/locale/mi": return import(/* webpackChunkName: "moment/locale/mi" */ "moment/locale/mi.js");
      
        case "moment/locale/mk": return import(/* webpackChunkName: "moment/locale/mk" */ "moment/locale/mk.js");
      
        case "moment/locale/ml": return import(/* webpackChunkName: "moment/locale/ml" */ "moment/locale/ml.js");
      
        case "moment/locale/mn": return import(/* webpackChunkName: "moment/locale/mn" */ "moment/locale/mn.js");
      
        case "moment/locale/mr": return import(/* webpackChunkName: "moment/locale/mr" */ "moment/locale/mr.js");
      
        case "moment/locale/ms-my": return import(/* webpackChunkName: "moment/locale/ms-my" */ "moment/locale/ms-my.js");
      
        case "moment/locale/ms": return import(/* webpackChunkName: "moment/locale/ms" */ "moment/locale/ms.js");
      
        case "moment/locale/mt": return import(/* webpackChunkName: "moment/locale/mt" */ "moment/locale/mt.js");
      
        case "moment/locale/my": return import(/* webpackChunkName: "moment/locale/my" */ "moment/locale/my.js");
      
        case "moment/locale/nb": return import(/* webpackChunkName: "moment/locale/nb" */ "moment/locale/nb.js");
      
        case "moment/locale/ne": return import(/* webpackChunkName: "moment/locale/ne" */ "moment/locale/ne.js");
      
        case "moment/locale/nl-be": return import(/* webpackChunkName: "moment/locale/nl-be" */ "moment/locale/nl-be.js");
      
        case "moment/locale/nl": return import(/* webpackChunkName: "moment/locale/nl" */ "moment/locale/nl.js");
      
        case "moment/locale/nn": return import(/* webpackChunkName: "moment/locale/nn" */ "moment/locale/nn.js");
      
        case "moment/locale/oc-lnc": return import(/* webpackChunkName: "moment/locale/oc-lnc" */ "moment/locale/oc-lnc.js");
      
        case "moment/locale/pa-in": return import(/* webpackChunkName: "moment/locale/pa-in" */ "moment/locale/pa-in.js");
      
        case "moment/locale/pt-br": return import(/* webpackChunkName: "moment/locale/pt-br" */ "moment/locale/pt-br.js");
      
        case "moment/locale/pt": return import(/* webpackChunkName: "moment/locale/pt" */ "moment/locale/pt.js");
      
        case "moment/locale/ro": return import(/* webpackChunkName: "moment/locale/ro" */ "moment/locale/ro.js");
      
        case "moment/locale/ru": return import(/* webpackChunkName: "moment/locale/ru" */ "moment/locale/ru.js");
      
        case "moment/locale/sd": return import(/* webpackChunkName: "moment/locale/sd" */ "moment/locale/sd.js");
      
        case "moment/locale/se": return import(/* webpackChunkName: "moment/locale/se" */ "moment/locale/se.js");
      
        case "moment/locale/si": return import(/* webpackChunkName: "moment/locale/si" */ "moment/locale/si.js");
      
        case "moment/locale/sk": return import(/* webpackChunkName: "moment/locale/sk" */ "moment/locale/sk.js");
      
        case "moment/locale/sq": return import(/* webpackChunkName: "moment/locale/sq" */ "moment/locale/sq.js");
      
        case "moment/locale/sr-cyrl": return import(/* webpackChunkName: "moment/locale/sr-cyrl" */ "moment/locale/sr-cyrl.js");
      
        case "moment/locale/sr": return import(/* webpackChunkName: "moment/locale/sr" */ "moment/locale/sr.js");
      
        case "moment/locale/ss": return import(/* webpackChunkName: "moment/locale/ss" */ "moment/locale/ss.js");
      
        case "moment/locale/sv": return import(/* webpackChunkName: "moment/locale/sv" */ "moment/locale/sv.js");
      
        case "moment/locale/sw": return import(/* webpackChunkName: "moment/locale/sw" */ "moment/locale/sw.js");
      
        case "moment/locale/ta": return import(/* webpackChunkName: "moment/locale/ta" */ "moment/locale/ta.js");
      
        case "moment/locale/te": return import(/* webpackChunkName: "moment/locale/te" */ "moment/locale/te.js");
      
        case "moment/locale/tet": return import(/* webpackChunkName: "moment/locale/tet" */ "moment/locale/tet.js");
      
        case "moment/locale/tg": return import(/* webpackChunkName: "moment/locale/tg" */ "moment/locale/tg.js");
      
        case "moment/locale/th": return import(/* webpackChunkName: "moment/locale/th" */ "moment/locale/th.js");
      
        case "moment/locale/tk": return import(/* webpackChunkName: "moment/locale/tk" */ "moment/locale/tk.js");
      
        case "moment/locale/tl-ph": return import(/* webpackChunkName: "moment/locale/tl-ph" */ "moment/locale/tl-ph.js");
      
        case "moment/locale/tlh": return import(/* webpackChunkName: "moment/locale/tlh" */ "moment/locale/tlh.js");
      
        case "moment/locale/tr": return import(/* webpackChunkName: "moment/locale/tr" */ "moment/locale/tr.js");
      
        case "moment/locale/tzl": return import(/* webpackChunkName: "moment/locale/tzl" */ "moment/locale/tzl.js");
      
        case "moment/locale/tzm-latn": return import(/* webpackChunkName: "moment/locale/tzm-latn" */ "moment/locale/tzm-latn.js");
      
        case "moment/locale/tzm": return import(/* webpackChunkName: "moment/locale/tzm" */ "moment/locale/tzm.js");
      
        case "moment/locale/ug-cn": return import(/* webpackChunkName: "moment/locale/ug-cn" */ "moment/locale/ug-cn.js");
      
        case "moment/locale/uk": return import(/* webpackChunkName: "moment/locale/uk" */ "moment/locale/uk.js");
      
        case "moment/locale/ur": return import(/* webpackChunkName: "moment/locale/ur" */ "moment/locale/ur.js");
      
        case "moment/locale/uz-latn": return import(/* webpackChunkName: "moment/locale/uz-latn" */ "moment/locale/uz-latn.js");
      
        case "moment/locale/uz": return import(/* webpackChunkName: "moment/locale/uz" */ "moment/locale/uz.js");
      
        case "moment/locale/vi": return import(/* webpackChunkName: "moment/locale/vi" */ "moment/locale/vi.js");
      
        case "moment/locale/x-pseudo": return import(/* webpackChunkName: "moment/locale/x-pseudo" */ "moment/locale/x-pseudo.js");
      
        case "moment/locale/yo": return import(/* webpackChunkName: "moment/locale/yo" */ "moment/locale/yo.js");
      
        case "moment/locale/zh-cn": return import(/* webpackChunkName: "moment/locale/zh-cn" */ "moment/locale/zh-cn.js");
      
        case "moment/locale/zh-hk": return import(/* webpackChunkName: "moment/locale/zh-hk" */ "moment/locale/zh-hk.js");
      
        case "moment/locale/zh-mo": return import(/* webpackChunkName: "moment/locale/zh-mo" */ "moment/locale/zh-mo.js");
      
        case "moment/locale/zh-tw": return import(/* webpackChunkName: "moment/locale/zh-tw" */ "moment/locale/zh-tw.js");
      
        case "moment/locale/ca": return import(/* webpackChunkName: "moment/locale/ca" */ "/var/canvas/ui/ext/custom_moment_locales/ca.js");
      
        case "moment/locale/de": return import(/* webpackChunkName: "moment/locale/de" */ "/var/canvas/ui/ext/custom_moment_locales/de.js");
      
        case "moment/locale/fa": return import(/* webpackChunkName: "moment/locale/fa" */ "/var/canvas/ui/ext/custom_moment_locales/fa.js");
      
        case "moment/locale/fr": return import(/* webpackChunkName: "moment/locale/fr" */ "/var/canvas/ui/ext/custom_moment_locales/fr.js");
      
        case "moment/locale/fr-ca": return import(/* webpackChunkName: "moment/locale/fr-ca" */ "/var/canvas/ui/ext/custom_moment_locales/fr_ca.js");
      
        case "moment/locale/he": return import(/* webpackChunkName: "moment/locale/he" */ "/var/canvas/ui/ext/custom_moment_locales/he.js");
      
        case "moment/locale/ht-ht": return import(/* webpackChunkName: "moment/locale/ht-ht" */ "/var/canvas/ui/ext/custom_moment_locales/ht_ht.js");
      
        case "moment/locale/hy-am": return import(/* webpackChunkName: "moment/locale/hy-am" */ "/var/canvas/ui/ext/custom_moment_locales/hy_am.js");
      
        case "moment/locale/mi-nz": return import(/* webpackChunkName: "moment/locale/mi-nz" */ "/var/canvas/ui/ext/custom_moment_locales/mi_nz.js");
      
        case "moment/locale/pl": return import(/* webpackChunkName: "moment/locale/pl" */ "/var/canvas/ui/ext/custom_moment_locales/pl.js");
      
        case "moment/locale/sl": return import(/* webpackChunkName: "moment/locale/sl" */ "/var/canvas/ui/ext/custom_moment_locales/sl.js");
      

      default:
        console.warn("couldn't load moment/locale/", locale)
    }
  }
  loadLocale('moment/locale/' + ENV.MOMENT_LOCALE)
}

export default function loadBundle(bundleName) {
  switch (bundleName) {
    
      case "account_admin_tools": return import(/* webpackChunkName: "account_admin_tools" */ "/var/canvas/ui/features/account_admin_tools/index.js");
    
      case "account_calendar_settings": return import(/* webpackChunkName: "account_calendar_settings" */ "/var/canvas/ui/features/account_calendar_settings/index.tsx");
    
      case "account_course_user_search": return import(/* webpackChunkName: "account_course_user_search" */ "/var/canvas/ui/features/account_course_user_search/index.js");
    
      case "account_grading_standards": return import(/* webpackChunkName: "account_grading_standards" */ "/var/canvas/ui/features/account_grading_standards/index.js");
    
      case "account_notification_settings": return import(/* webpackChunkName: "account_notification_settings" */ "/var/canvas/ui/features/account_notification_settings/index.js");
    
      case "account_search": return import(/* webpackChunkName: "account_search" */ "/var/canvas/ui/features/account_search/index.js");
    
      case "account_settings": return import(/* webpackChunkName: "account_settings" */ "/var/canvas/ui/features/account_settings/index.js");
    
      case "account_statistics": return import(/* webpackChunkName: "account_statistics" */ "/var/canvas/ui/features/account_statistics/index.js");
    
      case "act_as_modal": return import(/* webpackChunkName: "act_as_modal" */ "/var/canvas/ui/features/act_as_modal/index.js");
    
      case "admin_split": return import(/* webpackChunkName: "admin_split" */ "/var/canvas/ui/features/admin_split/index.js");
    
      case "alerts": return import(/* webpackChunkName: "alerts" */ "/var/canvas/ui/features/alerts/index.js");
    
      case "all_courses": return import(/* webpackChunkName: "all_courses" */ "/var/canvas/ui/features/all_courses/index.js");
    
      case "announcements_on_home_page": return import(/* webpackChunkName: "announcements_on_home_page" */ "/var/canvas/ui/features/announcements_on_home_page/index.js");
    
      case "announcements": return import(/* webpackChunkName: "announcements" */ "/var/canvas/ui/features/announcements/index.js");
    
      case "assignment_edit": return import(/* webpackChunkName: "assignment_edit" */ "/var/canvas/ui/features/assignment_edit/index.js");
    
      case "assignment_grade_summary": return import(/* webpackChunkName: "assignment_grade_summary" */ "/var/canvas/ui/features/assignment_grade_summary/index.js");
    
      case "assignment_index": return import(/* webpackChunkName: "assignment_index" */ "/var/canvas/ui/features/assignment_index/index.js");
    
      case "assignment_show": return import(/* webpackChunkName: "assignment_show" */ "/var/canvas/ui/features/assignment_show/index.js");
    
      case "assignments_peer_reviews": return import(/* webpackChunkName: "assignments_peer_reviews" */ "/var/canvas/ui/features/assignments_peer_reviews/index.js");
    
      case "assignments_show_student": return import(/* webpackChunkName: "assignments_show_student" */ "/var/canvas/ui/features/assignments_show_student/index.js");
    
      case "assignments_show_teacher": return import(/* webpackChunkName: "assignments_show_teacher" */ "/var/canvas/ui/features/assignments_show_teacher/index.js");
    
      case "authentication_providers": return import(/* webpackChunkName: "authentication_providers" */ "/var/canvas/ui/features/authentication_providers/index.js");
    
      case "available_pronouns_list": return import(/* webpackChunkName: "available_pronouns_list" */ "/var/canvas/ui/features/available_pronouns_list/index.js");
    
      case "blueprint_course_child": return import(/* webpackChunkName: "blueprint_course_child" */ "/var/canvas/ui/features/blueprint_course_child/index.js");
    
      case "blueprint_course_master": return import(/* webpackChunkName: "blueprint_course_master" */ "/var/canvas/ui/features/blueprint_course_master/index.js");
    
      case "brand_configs": return import(/* webpackChunkName: "brand_configs" */ "/var/canvas/ui/features/brand_configs/index.js");
    
      case "calendar_appointment_group_edit": return import(/* webpackChunkName: "calendar_appointment_group_edit" */ "/var/canvas/ui/features/calendar_appointment_group_edit/index.js");
    
      case "calendar": return import(/* webpackChunkName: "calendar" */ "/var/canvas/ui/features/calendar/index.js");
    
      case "change_password": return import(/* webpackChunkName: "change_password" */ "/var/canvas/ui/features/change_password/index.js");
    
      case "choose_mastery_path": return import(/* webpackChunkName: "choose_mastery_path" */ "/var/canvas/ui/features/choose_mastery_path/index.js");
    
      case "collaborations": return import(/* webpackChunkName: "collaborations" */ "/var/canvas/ui/features/collaborations/index.js");
    
      case "conferences": return import(/* webpackChunkName: "conferences" */ "/var/canvas/ui/features/conferences/index.js");
    
      case "confetti": return import(/* webpackChunkName: "confetti" */ "/var/canvas/ui/features/confetti/index.js");
    
      case "confirm_email": return import(/* webpackChunkName: "confirm_email" */ "/var/canvas/ui/features/confirm_email/index.js");
    
      case "content_exports": return import(/* webpackChunkName: "content_exports" */ "/var/canvas/ui/features/content_exports/index.js");
    
      case "content_migrations": return import(/* webpackChunkName: "content_migrations" */ "/var/canvas/ui/features/content_migrations/index.js");
    
      case "content_notices": return import(/* webpackChunkName: "content_notices" */ "/var/canvas/ui/features/content_notices/index.js");
    
      case "content_shares": return import(/* webpackChunkName: "content_shares" */ "/var/canvas/ui/features/content_shares/index.js");
    
      case "context_media_object_inline": return import(/* webpackChunkName: "context_media_object_inline" */ "/var/canvas/ui/features/context_media_object_inline/index.js");
    
      case "context_module_progressions": return import(/* webpackChunkName: "context_module_progressions" */ "/var/canvas/ui/features/context_module_progressions/index.js");
    
      case "context_modules": return import(/* webpackChunkName: "context_modules" */ "/var/canvas/ui/features/context_modules/index.js");
    
      case "context_roster_usage": return import(/* webpackChunkName: "context_roster_usage" */ "/var/canvas/ui/features/context_roster_usage/index.js");
    
      case "context_roster_user_services": return import(/* webpackChunkName: "context_roster_user_services" */ "/var/canvas/ui/features/context_roster_user_services/index.js");
    
      case "context_roster_user": return import(/* webpackChunkName: "context_roster_user" */ "/var/canvas/ui/features/context_roster_user/index.js");
    
      case "context_undelete_item": return import(/* webpackChunkName: "context_undelete_item" */ "/var/canvas/ui/features/context_undelete_item/index.js");
    
      case "conversations": return import(/* webpackChunkName: "conversations" */ "/var/canvas/ui/features/conversations/index.js");
    
      case "copy_course": return import(/* webpackChunkName: "copy_course" */ "/var/canvas/ui/features/copy_course/index.js");
    
      case "course_grading_standards": return import(/* webpackChunkName: "course_grading_standards" */ "/var/canvas/ui/features/course_grading_standards/index.js");
    
      case "course_link_validator": return import(/* webpackChunkName: "course_link_validator" */ "/var/canvas/ui/features/course_link_validator/index.js");
    
      case "course_list": return import(/* webpackChunkName: "course_list" */ "/var/canvas/ui/features/course_list/index.js");
    
      case "course_notification_settings": return import(/* webpackChunkName: "course_notification_settings" */ "/var/canvas/ui/features/course_notification_settings/index.js");
    
      case "course_paces": return import(/* webpackChunkName: "course_paces" */ "/var/canvas/ui/features/course_paces/index.tsx");
    
      case "course_people": return import(/* webpackChunkName: "course_people" */ "/var/canvas/ui/features/course_people/index.js");
    
      case "course_settings": return import(/* webpackChunkName: "course_settings" */ "/var/canvas/ui/features/course_settings/index.js");
    
      case "course_show": return import(/* webpackChunkName: "course_show" */ "/var/canvas/ui/features/course_show/index.js");
    
      case "course_statistics": return import(/* webpackChunkName: "course_statistics" */ "/var/canvas/ui/features/course_statistics/index.js");
    
      case "course_wizard": return import(/* webpackChunkName: "course_wizard" */ "/var/canvas/ui/features/course_wizard/index.js");
    
      case "course": return import(/* webpackChunkName: "course" */ "/var/canvas/ui/features/course/index.js");
    
      case "dashboard": return import(/* webpackChunkName: "dashboard" */ "/var/canvas/ui/features/dashboard/index.js");
    
      case "deep_linking_response": return import(/* webpackChunkName: "deep_linking_response" */ "/var/canvas/ui/features/deep_linking_response/index.ts");
    
      case "developer_keys_v2": return import(/* webpackChunkName: "developer_keys_v2" */ "/var/canvas/ui/features/developer_keys_v2/index.js");
    
      case "discussion_topic_edit_v2": return import(/* webpackChunkName: "discussion_topic_edit_v2" */ "/var/canvas/ui/features/discussion_topic_edit_v2/index.js");
    
      case "discussion_topic_edit": return import(/* webpackChunkName: "discussion_topic_edit" */ "/var/canvas/ui/features/discussion_topic_edit/index.js");
    
      case "discussion_topic": return import(/* webpackChunkName: "discussion_topic" */ "/var/canvas/ui/features/discussion_topic/index.js");
    
      case "discussion_topics_index": return import(/* webpackChunkName: "discussion_topics_index" */ "/var/canvas/ui/features/discussion_topics_index/index.js");
    
      case "discussion_topics_post": return import(/* webpackChunkName: "discussion_topics_post" */ "/var/canvas/ui/features/discussion_topics_post/index.js");
    
      case "edit_calendar_event": return import(/* webpackChunkName: "edit_calendar_event" */ "/var/canvas/ui/features/edit_calendar_event/index.js");
    
      case "edit_rubric": return import(/* webpackChunkName: "edit_rubric" */ "/var/canvas/ui/features/edit_rubric/index.js");
    
      case "eportfolio": return import(/* webpackChunkName: "eportfolio" */ "/var/canvas/ui/features/eportfolio/index.js");
    
      case "eportfolios_wizard_box": return import(/* webpackChunkName: "eportfolios_wizard_box" */ "/var/canvas/ui/features/eportfolios_wizard_box/index.js");
    
      case "epub_exports": return import(/* webpackChunkName: "epub_exports" */ "/var/canvas/ui/features/epub_exports/index.js");
    
      case "error_form": return import(/* webpackChunkName: "error_form" */ "/var/canvas/ui/features/error_form/index.js");
    
      case "external_apps": return import(/* webpackChunkName: "external_apps" */ "/var/canvas/ui/features/external_apps/index.js");
    
      case "external_content_cancel": return import(/* webpackChunkName: "external_content_cancel" */ "/var/canvas/ui/features/external_content_cancel/index.js");
    
      case "external_content_success": return import(/* webpackChunkName: "external_content_success" */ "/var/canvas/ui/features/external_content_success/index.js");
    
      case "external_tool_redirect": return import(/* webpackChunkName: "external_tool_redirect" */ "/var/canvas/ui/features/external_tool_redirect/index.js");
    
      case "external_tools_show": return import(/* webpackChunkName: "external_tools_show" */ "/var/canvas/ui/features/external_tools_show/index.js");
    
      case "file_not_found": return import(/* webpackChunkName: "file_not_found" */ "/var/canvas/ui/features/file_not_found/index.js");
    
      case "file_preview": return import(/* webpackChunkName: "file_preview" */ "/var/canvas/ui/features/file_preview/index.js");
    
      case "file_show": return import(/* webpackChunkName: "file_show" */ "/var/canvas/ui/features/file_show/index.js");
    
      case "file": return import(/* webpackChunkName: "file" */ "/var/canvas/ui/features/file/index.js");
    
      case "files": return import(/* webpackChunkName: "files" */ "/var/canvas/ui/features/files/index.js");
    
      case "grade_summary": return import(/* webpackChunkName: "grade_summary" */ "/var/canvas/ui/features/grade_summary/index.js");
    
      case "gradebook_history": return import(/* webpackChunkName: "gradebook_history" */ "/var/canvas/ui/features/gradebook_history/index.js");
    
      case "gradebook_uploads": return import(/* webpackChunkName: "gradebook_uploads" */ "/var/canvas/ui/features/gradebook_uploads/index.js");
    
      case "gradebook": return import(/* webpackChunkName: "gradebook" */ "/var/canvas/ui/features/gradebook/index.tsx");
    
      case "graphiql": return import(/* webpackChunkName: "graphiql" */ "/var/canvas/ui/features/graphiql/index.js");
    
      case "group_submission_reminder": return import(/* webpackChunkName: "group_submission_reminder" */ "/var/canvas/ui/features/group_submission_reminder/index.js");
    
      case "groups": return import(/* webpackChunkName: "groups" */ "/var/canvas/ui/features/groups/index.js");
    
      case "inbox": return import(/* webpackChunkName: "inbox" */ "/var/canvas/ui/features/inbox/index.js");
    
      case "inlined_preview": return import(/* webpackChunkName: "inlined_preview" */ "/var/canvas/ui/features/inlined_preview/index.js");
    
      case "inst_fs_service_worker": return import(/* webpackChunkName: "inst_fs_service_worker" */ "/var/canvas/ui/features/inst_fs_service_worker/index.js");
    
      case "jobs_v2": return import(/* webpackChunkName: "jobs_v2" */ "/var/canvas/ui/features/jobs_v2/index.js");
    
      case "jobs": return import(/* webpackChunkName: "jobs" */ "/var/canvas/ui/features/jobs/index.js");
    
      case "k5_course": return import(/* webpackChunkName: "k5_course" */ "/var/canvas/ui/features/k5_course/index.js");
    
      case "k5_dashboard": return import(/* webpackChunkName: "k5_dashboard" */ "/var/canvas/ui/features/k5_dashboard/index.js");
    
      case "k5_theme": return import(/* webpackChunkName: "k5_theme" */ "/var/canvas/ui/features/k5_theme/index.js");
    
      case "ldap_settings_test": return import(/* webpackChunkName: "ldap_settings_test" */ "/var/canvas/ui/features/ldap_settings_test/index.js");
    
      case "learning_mastery_v2": return import(/* webpackChunkName: "learning_mastery_v2" */ "/var/canvas/ui/features/learning_mastery_v2/index.js");
    
      case "learning_mastery": return import(/* webpackChunkName: "learning_mastery" */ "/var/canvas/ui/features/learning_mastery/index.js");
    
      case "learning_outcomes": return import(/* webpackChunkName: "learning_outcomes" */ "/var/canvas/ui/features/learning_outcomes/index.js");
    
      case "license_help": return import(/* webpackChunkName: "license_help" */ "/var/canvas/ui/features/license_help/index.js");
    
      case "link_enrollment": return import(/* webpackChunkName: "link_enrollment" */ "/var/canvas/ui/features/link_enrollment/index.js");
    
      case "locale": return import(/* webpackChunkName: "locale" */ "/var/canvas/ui/features/locale/index.js");
    
      case "login": return import(/* webpackChunkName: "login" */ "/var/canvas/ui/features/login/index.js");
    
      case "lti_collaborations": return import(/* webpackChunkName: "lti_collaborations" */ "/var/canvas/ui/features/lti_collaborations/index.js");
    
      case "manage_avatars": return import(/* webpackChunkName: "manage_avatars" */ "/var/canvas/ui/features/manage_avatars/index.js");
    
      case "manage_groups": return import(/* webpackChunkName: "manage_groups" */ "/var/canvas/ui/features/manage_groups/index.js");
    
      case "media_player_iframe_content": return import(/* webpackChunkName: "media_player_iframe_content" */ "/var/canvas/ui/features/media_player_iframe_content/index.js");
    
      case "messages": return import(/* webpackChunkName: "messages" */ "/var/canvas/ui/features/messages/index.js");
    
      case "mobile_login": return import(/* webpackChunkName: "mobile_login" */ "/var/canvas/ui/features/mobile_login/index.js");
    
      case "moderate_quiz": return import(/* webpackChunkName: "moderate_quiz" */ "/var/canvas/ui/features/moderate_quiz/index.js");
    
      case "module_dnd": return import(/* webpackChunkName: "module_dnd" */ "/var/canvas/ui/features/module_dnd/index.js");
    
      case "module_sequence_footer": return import(/* webpackChunkName: "module_sequence_footer" */ "/var/canvas/ui/features/module_sequence_footer/index.js");
    
      case "nav_tourpoints": return import(/* webpackChunkName: "nav_tourpoints" */ "/var/canvas/ui/features/nav_tourpoints/index.js");
    
      case "navigation_header": return import(/* webpackChunkName: "navigation_header" */ "/var/canvas/ui/features/navigation_header/index.js");
    
      case "new_user_tutorial": return import(/* webpackChunkName: "new_user_tutorial" */ "/var/canvas/ui/features/new_user_tutorial/index.js");
    
      case "not_found_index": return import(/* webpackChunkName: "not_found_index" */ "/var/canvas/ui/features/not_found_index/index.js");
    
      case "oauth2_confirm": return import(/* webpackChunkName: "oauth2_confirm" */ "/var/canvas/ui/features/oauth2_confirm/index.js");
    
      case "otp_login": return import(/* webpackChunkName: "otp_login" */ "/var/canvas/ui/features/otp_login/index.js");
    
      case "outcome_alignment_v2": return import(/* webpackChunkName: "outcome_alignment_v2" */ "/var/canvas/ui/features/outcome_alignment_v2/index.js");
    
      case "outcome_alignments": return import(/* webpackChunkName: "outcome_alignments" */ "/var/canvas/ui/features/outcome_alignments/index.js");
    
      case "outcome_management": return import(/* webpackChunkName: "outcome_management" */ "/var/canvas/ui/features/outcome_management/index.js");
    
      case "page_views": return import(/* webpackChunkName: "page_views" */ "/var/canvas/ui/features/page_views/index.js");
    
      case "past_global_alert": return import(/* webpackChunkName: "past_global_alert" */ "/var/canvas/ui/features/past_global_alert/index.js");
    
      case "past_global_announcements": return import(/* webpackChunkName: "past_global_announcements" */ "/var/canvas/ui/features/past_global_announcements/index.js");
    
      case "permissions": return import(/* webpackChunkName: "permissions" */ "/var/canvas/ui/features/permissions/index.js");
    
      case "plugins": return import(/* webpackChunkName: "plugins" */ "/var/canvas/ui/features/plugins/index.js");
    
      case "prerequisites_lookup": return import(/* webpackChunkName: "prerequisites_lookup" */ "/var/canvas/ui/features/prerequisites_lookup/index.js");
    
      case "profile_show": return import(/* webpackChunkName: "profile_show" */ "/var/canvas/ui/features/profile_show/index.js");
    
      case "profile": return import(/* webpackChunkName: "profile" */ "/var/canvas/ui/features/profile/index.js");
    
      case "progress_pill": return import(/* webpackChunkName: "progress_pill" */ "/var/canvas/ui/features/progress_pill/index.js");
    
      case "qr_mobile_login": return import(/* webpackChunkName: "qr_mobile_login" */ "/var/canvas/ui/features/qr_mobile_login/index.js");
    
      case "question_bank": return import(/* webpackChunkName: "question_bank" */ "/var/canvas/ui/features/question_bank/index.js");
    
      case "question_banks": return import(/* webpackChunkName: "question_banks" */ "/var/canvas/ui/features/question_banks/index.js");
    
      case "quiz_history": return import(/* webpackChunkName: "quiz_history" */ "/var/canvas/ui/features/quiz_history/index.js");
    
      case "quiz_log_auditing": return import(/* webpackChunkName: "quiz_log_auditing" */ "/var/canvas/ui/features/quiz_log_auditing/index.js");
    
      case "quiz_migration_alerts": return import(/* webpackChunkName: "quiz_migration_alerts" */ "/var/canvas/ui/features/quiz_migration_alerts/index.js");
    
      case "quiz_show": return import(/* webpackChunkName: "quiz_show" */ "/var/canvas/ui/features/quiz_show/index.js");
    
      case "quiz_statistics": return import(/* webpackChunkName: "quiz_statistics" */ "/var/canvas/ui/features/quiz_statistics/index.js");
    
      case "quiz_submission": return import(/* webpackChunkName: "quiz_submission" */ "/var/canvas/ui/features/quiz_submission/index.js");
    
      case "quizzes_access_code": return import(/* webpackChunkName: "quizzes_access_code" */ "/var/canvas/ui/features/quizzes_access_code/index.js");
    
      case "quizzes_index": return import(/* webpackChunkName: "quizzes_index" */ "/var/canvas/ui/features/quizzes_index/index.js");
    
      case "quizzes": return import(/* webpackChunkName: "quizzes" */ "/var/canvas/ui/features/quizzes/index.js");
    
      case "registration_confirmation": return import(/* webpackChunkName: "registration_confirmation" */ "/var/canvas/ui/features/registration_confirmation/index.js");
    
      case "registration": return import(/* webpackChunkName: "registration" */ "/var/canvas/ui/features/registration/index.js");
    
      case "release_notes_edit": return import(/* webpackChunkName: "release_notes_edit" */ "/var/canvas/ui/features/release_notes_edit/index.js");
    
      case "roster": return import(/* webpackChunkName: "roster" */ "/var/canvas/ui/features/roster/index.js");
    
      case "rubric_assessment": return import(/* webpackChunkName: "rubric_assessment" */ "/var/canvas/ui/features/rubric_assessment/index.js");
    
      case "rubrics_index": return import(/* webpackChunkName: "rubrics_index" */ "/var/canvas/ui/features/rubrics_index/index.js");
    
      case "rubrics_show": return import(/* webpackChunkName: "rubrics_show" */ "/var/canvas/ui/features/rubrics_show/index.js");
    
      case "screenreader_gradebook": return import(/* webpackChunkName: "screenreader_gradebook" */ "/var/canvas/ui/features/screenreader_gradebook/index.js");
    
      case "section": return import(/* webpackChunkName: "section" */ "/var/canvas/ui/features/section/index.js");
    
      case "select_content_dialog": return import(/* webpackChunkName: "select_content_dialog" */ "/var/canvas/ui/features/select_content_dialog/index.js");
    
      case "self_enrollment": return import(/* webpackChunkName: "self_enrollment" */ "/var/canvas/ui/features/self_enrollment/index.js");
    
      case "sis_import": return import(/* webpackChunkName: "sis_import" */ "/var/canvas/ui/features/sis_import/index.js");
    
      case "slickgrid": return import(/* webpackChunkName: "slickgrid" */ "/var/canvas/ui/features/slickgrid/index.js");
    
      case "speed_grader": return import(/* webpackChunkName: "speed_grader" */ "/var/canvas/ui/features/speed_grader/index.js");
    
      case "student_group_dialog": return import(/* webpackChunkName: "student_group_dialog" */ "/var/canvas/ui/features/student_group_dialog/index.js");
    
      case "sub_accounts": return import(/* webpackChunkName: "sub_accounts" */ "/var/canvas/ui/features/sub_accounts/index.js");
    
      case "submission_download": return import(/* webpackChunkName: "submission_download" */ "/var/canvas/ui/features/submission_download/index.js");
    
      case "submissions_show_preview_media": return import(/* webpackChunkName: "submissions_show_preview_media" */ "/var/canvas/ui/features/submissions_show_preview_media/index.js");
    
      case "submissions_show_preview_text": return import(/* webpackChunkName: "submissions_show_preview_text" */ "/var/canvas/ui/features/submissions_show_preview_text/index.js");
    
      case "submissions_show_preview_upload": return import(/* webpackChunkName: "submissions_show_preview_upload" */ "/var/canvas/ui/features/submissions_show_preview_upload/index.js");
    
      case "submissions": return import(/* webpackChunkName: "submissions" */ "/var/canvas/ui/features/submissions/index.js");
    
      case "submit_assignment": return import(/* webpackChunkName: "submit_assignment" */ "/var/canvas/ui/features/submit_assignment/index.js");
    
      case "syllabus": return import(/* webpackChunkName: "syllabus" */ "/var/canvas/ui/features/syllabus/index.js");
    
      case "take_quiz": return import(/* webpackChunkName: "take_quiz" */ "/var/canvas/ui/features/take_quiz/index.js");
    
      case "teacher_activity_report": return import(/* webpackChunkName: "teacher_activity_report" */ "/var/canvas/ui/features/teacher_activity_report/index.js");
    
      case "terms_index": return import(/* webpackChunkName: "terms_index" */ "/var/canvas/ui/features/terms_index/index.js");
    
      case "terms_of_service_modal": return import(/* webpackChunkName: "terms_of_service_modal" */ "/var/canvas/ui/features/terms_of_service_modal/index.js");
    
      case "terms_of_use": return import(/* webpackChunkName: "terms_of_use" */ "/var/canvas/ui/features/terms_of_use/index.js");
    
      case "theme_editor": return import(/* webpackChunkName: "theme_editor" */ "/var/canvas/ui/features/theme_editor/index.js");
    
      case "theme_preview": return import(/* webpackChunkName: "theme_preview" */ "/var/canvas/ui/features/theme_preview/index.js");
    
      case "user_grades": return import(/* webpackChunkName: "user_grades" */ "/var/canvas/ui/features/user_grades/index.js");
    
      case "user_lists": return import(/* webpackChunkName: "user_lists" */ "/var/canvas/ui/features/user_lists/index.js");
    
      case "user_logins": return import(/* webpackChunkName: "user_logins" */ "/var/canvas/ui/features/user_logins/index.js");
    
      case "user_name": return import(/* webpackChunkName: "user_name" */ "/var/canvas/ui/features/user_name/index.js");
    
      case "user_notes": return import(/* webpackChunkName: "user_notes" */ "/var/canvas/ui/features/user_notes/index.js");
    
      case "user_observees": return import(/* webpackChunkName: "user_observees" */ "/var/canvas/ui/features/user_observees/index.js");
    
      case "user_outcome_results": return import(/* webpackChunkName: "user_outcome_results" */ "/var/canvas/ui/features/user_outcome_results/index.js");
    
      case "user": return import(/* webpackChunkName: "user" */ "/var/canvas/ui/features/user/index.js");
    
      case "users_admin_merge": return import(/* webpackChunkName: "users_admin_merge" */ "/var/canvas/ui/features/users_admin_merge/index.js");
    
      case "users_index": return import(/* webpackChunkName: "users_index" */ "/var/canvas/ui/features/users_index/index.js");
    
      case "visibility_help": return import(/* webpackChunkName: "visibility_help" */ "/var/canvas/ui/features/visibility_help/index.js");
    
      case "webzip_export": return import(/* webpackChunkName: "webzip_export" */ "/var/canvas/ui/features/webzip_export/index.js");
    
      case "wiki_page_edit": return import(/* webpackChunkName: "wiki_page_edit" */ "/var/canvas/ui/features/wiki_page_edit/index.js");
    
      case "wiki_page_index": return import(/* webpackChunkName: "wiki_page_index" */ "/var/canvas/ui/features/wiki_page_index/index.js");
    
      case "wiki_page_revisions": return import(/* webpackChunkName: "wiki_page_revisions" */ "/var/canvas/ui/features/wiki_page_revisions/index.js");
    
      case "wiki_page_show": return import(/* webpackChunkName: "wiki_page_show" */ "/var/canvas/ui/features/wiki_page_show/index.js");
    
      case "analytics-course": return import(/* webpackChunkName: "analytics-course" */ "../gems/plugins/analytics/app/jsx/bundles/course.js");
    
      case "analytics-department": return import(/* webpackChunkName: "analytics-department" */ "../gems/plugins/analytics/app/jsx/bundles/department.js");
    
      case "analytics-student_in_course": return import(/* webpackChunkName: "analytics-student_in_course" */ "../gems/plugins/analytics/app/jsx/bundles/student_in_course.js");
    

    default:
      throw new Error("couldn't find bundle " + bundleName)
  }
}
